import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IUpdateFn, ITrainingGroupUpsert, ITrainingGroup, IGetPutRequest } from '../../interfaces'

const getUpdateTrainingGroupMutationRequest: IGetPutRequest = params => {

  return {
    method: 'put',
    url: `${config.baseUrl}/TrainingGroups/`,
  }
}

const useUpdateTrainingGroupMutation: IUseUpdateMutation<ITrainingGroup, ITrainingGroupUpsert> = (params, options = {}) => {
  const request = useMemo(() => getUpdateTrainingGroupMutationRequest(params), [params])

  const updateTraining: IUpdateFn<ITrainingGroupUpsert, ITrainingGroup> = useCallback(
    async data => {
      return axios({ ...request, url: request.url + data.id, data }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ITrainingGroup, Error, any>({
    mutationFn: updateTraining,
    ...options,
  })

  return response
}

export default useUpdateTrainingGroupMutation
